import { FunctionType } from '@generated/globalTypes';

/**
 * This function is made to override our default fieldNameDenormalizer on a mutation level.
 * This is useful when some fields need to be in camel case instead of snake case and vice-versa.
 * @param fieldName - name of the field
 * @returns formatted field name
 */
export const fieldNameDenormalizerOverride = ((fieldName: string) => fieldName) as FunctionType;
